<template>
  <UiModal
    :is-shown="open"
    :teleport-target="modalTarget || undefined"
    :is-closed-by-click-outside="false"
    modal-class="modal-sight"
    size="m"
    is-header-fixed
    :title="sight.name"
    :is-content-no-padding="true"
    :is-footer-hidden="true"
    :is-close-button-filled="true"
    @close="emit('close')"
  >
    <template #content>
      <ModalContainer
        v-if="open"
        :city="city"
        :sight="sight"
        :modal-nav="modalNav"
        :nav-is-loading="navIsLoading"
        :guide-comments="guideComments"
        :guide-share="guideShare"
        :has-more-guide-comments="hasMoreGuideComments"
        :analytics-base="analyticsBase"
        @show-more-guide-comments="emit('show-more-guide-comments')"
      >
        <template
          v-if="$slots.experience"
          #experience
        >
          <slot name="experience" />
        </template>
      </ModalContainer>
    </template>
  </UiModal>
</template>

<script setup lang="ts">
  import { UiModal } from '@experience/core-modal-ui';
  import { ref } from 'vue';

  import ModalContainer from '@/features/sights/ModalContainer.vue';
  import {
    defaultSightModalNav,
    type SightGuideComment,
    type SightModalCity,
    type SightModalNav,
    type SightModalSight,
  } from '@/shared/types/sight-modal';

  const props = withDefaults(
    defineProps<{
      open: boolean;
      city: SightModalCity;
      sight: SightModalSight;
      modalNav?: SightModalNav;
      navIsLoading?: boolean;
      guideComments?: SightGuideComment[];
      guideShare?: SightGuideComment | null;
      hasMoreGuideComments?: boolean;
      teleportTarget?: HTMLElement | null;
      analyticsBase?: Record<string, unknown>;
    }>(),
    {
      modalNav: () => defaultSightModalNav(),
      navIsLoading: false,
      guideComments: () => [],
      guideShare: null,
      hasMoreGuideComments: false,
      teleportTarget: null,
      analyticsBase: () => ({}),
    },
  );

  const emit = defineEmits<{
    close: [];
    'show-more-guide-comments': [];
  }>();

  const modalTarget = ref<HTMLElement | null>(props.teleportTarget ?? null);
</script>

<style>
  .modal-sight .ui-modal-header {
    z-index: 12 !important;
  }

  .modal-sight .ui-modal-body {
    overflow: visible !important;
  }
</style>
